var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"disabled":!_vm.islogin,"icon":""},on:{"click":_vm.love}},[(_vm.islove)?_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-heart")]):_c('v-icon',[_vm._v("mdi-heart-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }